import React from 'react';
import { Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';

// Colonne d'identité pour les tables de liaison user ↔ (projet | billing account).
//
// Ces deux tables (`qm_project_users`, `qm_billing_account_users`) partagent la même
// forme : une invitation est créée avec un `email` et `user_id = NULL`, et ne reçoit un
// `user_id` qu'à l'acceptation. Afficher `user.name` brut laissait donc une cellule vide
// sur toute invitation en attente — une ligne anonyme, impossible à relier à qui que ce
// soit depuis l'admin.
//
// On retombe sur l'email (celui du compte s'il existe, sinon celui de l'invitation, seule
// identité connue à ce stade) et on marque explicitement le pending, pour que la ligne se
// lise comme une invitation en attente et non comme un compte cassé.

// #region UserIdentityField
interface UserIdentityFieldProps {
	// Consommé par le header du Datagrid react-admin, pas par le rendu ci-dessous.
	label?: string;
	sortable?: boolean;
}

const UserIdentityField: React.FC<UserIdentityFieldProps> = () => {
	const record = useRecordContext<any>();

	const name = record?.user?.name?.trim();
	if (name) return <span>{name}</span>;

	const email = record?.user?.email || record?.email;
	if (!email) {
		return (
			<Typography component="span" variant="body2" color="text.disabled">
				— unknown —
			</Typography>
		);
	}

	// `status` peut être absent de la payload selon l'endpoint : on ne montre le badge
	// que sur un pending explicite, jamais par défaut.
	const isPending = record?.status === 0;

	return (
		<span>
			{email}
			{isPending && (
				<Typography component="span" variant="caption" sx={{ ml: 1, color: 'warning.main' }}>
					(invitation pending)
				</Typography>
			)}
		</span>
	);
};
// #endregion

export default UserIdentityField;
